import React from 'react';

interface FormProps {
    children?: React.ReactNode;
    error?: string;
    onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
    innerRef?: React.Ref<HTMLFormElement>;
}

const Form: React.FC<FormProps> = ({ children, onSubmit, innerRef }) => (
    <form
        onSubmit={(event) => {
            if (onSubmit) {
                event.preventDefault();
                onSubmit(event);
                return false;
            }
        }}
        ref={innerRef}
    >
        {children}
    </form>
);

export { Form };
